import type { Mitteilung } from '@/types/Mitteilung.ts';
import { SharedMitteilungService } from '@/shared/api/services/mitteilung.ts';

export class MitteilungService extends SharedMitteilungService {
  async holeMitteilung(mitteilungId: string): Promise<Mitteilung> {
    const result = await this.httpClient.get<{
      buergschaftId: number;
      mitteilung: Mitteilung;
    }>(`${this.baseUrl}/mitteilung/${mitteilungId}`);

    return result.mitteilung;
  }
}
